import { Component, OnInit ,Input} from '@angular/core';
import { trigger, transition, style, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  animations:[trigger('fade',[
    transition('void=>*',[
      style({transform:'translateX(100%)'}),
      animate('0.7s ease-out',style({transform:'translateX(0px)'}))

    ]),
    transition('*=>void',[
      animate('0.5s ease-in',keyframes([
        style({offset:.2,opacity:1,transform:'translateX(20px)'}),
        style({offset:1,opacity:0,transform:'translateX(100%)'})
      ]))

    ])                                                   

  ])]
})
export class NotificationComponent implements OnInit {
   show=true;
  @Input() type='type of notification'
  @Input() message='notification message'
  @Input() closeable=true
  @Input() fullWidth=false
  constructor() { }

  ngOnInit() {
  }
  close(){
    this.show=false;
  }
  setting(){
    return {
      'fullwidth':this.fullWidth,
    }
  }

}
